import { useState } from "react";
import {
  EditOutlined,
  InfoCircleOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Button, Row, Table, Typography, Tooltip, Tag } from "antd";
import { Container } from "./elements";
import { GET_PRODUCTS } from "./requests";
import { useQuery } from "@apollo/client";
import DetailDrawer from "./components/detailModal";
import EditDrawer from "./components/createModal";
import { productTypes } from "../../utils/constants";
import { productTypes as typesProducts } from "../../types";
import TableTitle from "./table-title";
import DeleteProduct from "./components/deleteModal";

const { Text } = Typography;

export default function Products() {
  const [nameFilter, setNameFilter] = useState<string>("");
  const [typeFilter, setTypeFilter] = useState<string>("");
  const [params, setParams] = useState({ page: 1,
    pageSize: 10 });

  const { data, refetch, loading } = useQuery(GET_PRODUCTS, {
    variables: {
      params,
      name: nameFilter,
      type: typeFilter,
      excludeTypes: ["coupon"],
    },
  });
  const [openDetail, setOpenDetail] = useState(false);
  const [openCreate, setOpenCreate] = useState(false);
  const [isCreateView, setIsCreateView] = useState(false);
  const [productInfo, setProductInfo] = useState<typeof typesProducts.product | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [product, setProduct] = useState<typeof typesProducts.product | null>(null);

  const productColumns = [
    {
      width: "8%",
      dataIndex: "variants",
      key: "img",
      render: (variants) => {
        const primaryVariant = variants.find(variant => variant.isPrimaryVariant);
        return (
          <img
            src={primaryVariant.img}
            style={{ width: 80,
              height: 80,
              borderRadius: 50 }}
          />
        );
      },
    },
    {
      title: "Producto",
      key: "name",
      render: (row: any) => (
        <div>
          <Text strong style={{}}>
            {row?.name}
          </Text>
          <br />
          <Text strong style={{ color: "grey" }}>
            {productTypes[row?.type]}
          </Text>
        </div>
      ),
    },
    {
      title: "Categorias",
      dataIndex: "categories",
      key: "categories",
      render: (items) => {
        return (
          <Row>
            {items.map((item) => (
              <Tag key={item.id} color="blue">
                {item.category.name}
              </Tag>
            ))}
          </Row>
        );
      },
    },
    {
      title: "Precio",
      width: "10%",
      dataIndex: "variants",
      key: "price",
      render: (variants: { price: string }[]) => (
        <Tag color="green">{`$${variants[0]?.price}`}</Tag>
      ),
    },

    {
      title: "Variantes",
      width: "10%",
      dataIndex: "variants",
      key: "variants",
      render: (arr: { title: string }[]) => (
        <Text strong style={{}}>
          {arr.length}
        </Text>
      ),
    },
    {
      title: "Acción",
      key: "action",
      render: (row: typeof typesProducts.product) => (
        <Row>
          <Tooltip placement="top" title="Editar">
            <Button
              type="primary"
              icon={<EditOutlined style={{ color: "white" }} />}
              style={{ margin: 5 }}
              onClick={() => {
                setOpenCreate(!openCreate);
                setProductInfo(row);
                setIsCreateView(false)
              }}
            >
              Editar
            </Button>{" "}
          </Tooltip>
          <Tooltip placement="top" title="Información">
            <Button
              shape="circle"
              type="primary"
              size="large"
              icon={<InfoCircleOutlined style={{ color: "white" }} />}
              style={{ margin: 5 }}
              onClick={() => {
                setOpenDetail(!openDetail);
                setProductInfo(row);
              }}
            />
          </Tooltip>
          <Tooltip placement="top" title="Eliminar">
            <Button
              shape="circle"
              type="primary"
              size="large"
              danger
              icon={<DeleteOutlined />}
              style={{ margin: 5 }}
              onClick={() => {
                setShowDeleteModal(true);
                setProduct(row)
              }}
            />
          </Tooltip>
        </Row>
      ),
    },
  ];

  return (
    <Container
      style={{
        overflow: "scroll",
        height: "90vh",
        width: "100%",
      }}
    >
      <div>
        <Row justify="space-between" align="middle">
          <Button
            type="primary"
            icon={<PlusCircleOutlined />}
            onClick={async () => {
              setOpenCreate(!openCreate);
              setIsCreateView(true);
            }}
          >
            Crear Producto
          </Button>
        </Row>
        <br />
        <Table
          columns={productColumns}
          dataSource={data?.products?.results}
          rowKey="id"
          loading={loading}
          title={() => (
            <TableTitle
              setNameFilter={setNameFilter}
              setTypeFilter={setTypeFilter}
            />
          )}
          pagination={{
            current: Number(params.page),
            defaultCurrent: params.page,
            pageSize: Number(params.pageSize),
            defaultPageSize: params.pageSize,
            total: data?.products?.info?.count,
            showTotal: (total) => <Text disabled>{`${total} resultados`}</Text>,
            onChange: (page, pageSize) =>
              setParams({
                pageSize: Number(pageSize),
                page: Number(page),
              }),
          }}
        />
      </div>
      {openDetail ? (
        <DetailDrawer
          open={openDetail}
          setOpen={setOpenDetail}
          product={productInfo}
          setProduct={setProductInfo}
        />
      ) : null}
      {openCreate ? (
        <EditDrawer
          open={openCreate}
          setOpen={setOpenCreate}
          product={productInfo}
          setProduct={setProductInfo}
          refetch={refetch}
          isCreateView={isCreateView}
        />
      ) : null}
      <DeleteProduct
        refetch={refetch}
        open={showDeleteModal}
        setOpen={setShowDeleteModal}
        product={product}
        setProduct={setProduct}
      />
    </Container>
  );
}
